// plugin
import * as Sentry from "@sentry/vue";
import "@/plugins/vue-composition-api";
import "@/plugins/vue-toast-notification";
import "@/plugins/vue-cookies";
import "@/plugins/vue-js-modal";
require("twix");

// scss
import "@/styles/styles.scss";
import "@/styles/app.scss";

// custom directive
import "@/directives/mask-directive";
// import "@/directives/click-outside-directive";

import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import tinybox from "./plugins/vue-tinybox";
import vuePhoneNumberInput from "./plugins/vue-phone-number-input";

import axios from "axios";

import router from "./router";
import store from "./store";
import { resolveBrand } from "@/config/brand";

Vue.config.productionTip = false;

const brand = resolveBrand(window.location.hostname);
store.commit("setBrand", brand);
document.title = brand.pageTitle;

const faviconLink = document.querySelector("link[rel~='icon']");
if (faviconLink) {
  faviconLink.href = brand.favicon;
}

Sentry.init({
  App,
  dsn: "https://099756f2e58d76417469c43030c80d07@o4508954011041792.ingest.us.sentry.io/4508954047938560",
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  tinybox,
  vuePhoneNumberInput,
  render: (h) => h(App),
}).$mount("#app");

// axios.interceptors.response.use(undefined, (error) => {
//   if (error) {
//     const originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       store.dispatch("Logout");

//       return router.push({ name: "login" });
//     }
//   }
// });
